import { createContext, useContext, type ReactNode } from 'react';

export interface SessionInfo {
  displayName: string | null;
  accountName: string | null;
  // Fase 2 — null hasta que /api/auth/me resuelva (mismo momento que
  // displayName/accountName). El frontend nunca decide solo con esto — es
  // para ocultar UI que un member no puede usar, el 403 real vive en el
  // backend (requireOwner()).
  role: 'owner' | 'member' | null;
  // Registro público (2026-08-05) — DISTINTO de `role` (ese es por cuenta).
  // Administra la plataforma entera (aprueba/rechaza solicitudes de alta de
  // cualquier cuenta) — mismo criterio: solo gatea UI, el 403 real vive en
  // requirePlatformAdmin.
  isPlatformAdmin: boolean;
}

const SessionCtx = createContext<SessionInfo>({ displayName: null, accountName: null, role: null, isPlatformAdmin: false });

export function SessionProvider({ children, value }: { children: ReactNode; value: SessionInfo }) {
  return <SessionCtx.Provider value={value}>{children}</SessionCtx.Provider>;
}

export function useSession() {
  return useContext(SessionCtx);
}
